var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dd",
    { class: _vm._f("klass")(_vm.validate.$error) },
    [
      _vm.validate.$error
        ? [
            !_vm.validate.required
              ? _c("span", { staticClass: "errNote" }, [
                  _vm._v("ＪリーグIDを入力してください。"),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.validate.minLength || !_vm.validate.maxLength
              ? _c("span", { staticClass: "errNote" }, [
                  _vm._v(
                    "\n        ＪリーグIDは" +
                      _vm._s(_vm.validate.$params.minLength.min) +
                      "文字以上" +
                      _vm._s(_vm.validate.$params.maxLength.max) +
                      "文字以下で入力してください。\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.validate.jleagueIdRule
              ? _c("span", { staticClass: "errNote" }, [
                  _vm._v("ＪリーグIDで使用できない文字が含まれています。"),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUnique && !_vm.activateJleagueId
        ? _c("span", { staticClass: "errNote" }, [
            _vm._v(
              "ＪリーグIDの重複する会員が既に存在しています。別のＪリーグIDを設定してください。"
            ),
          ])
        : !_vm.activateJleagueId && _vm.isDuplicateJleagueId
        ? _c("span", { staticClass: "errNote" }, [
            _vm._v(
              "ＪリーグIDの重複する会員が既に存在しています。別のＪリーグIDを設定してください。"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSignup
        ? [
            _vm.editableJleagueId || !_vm.isUnique
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.validate.$model,
                      expression: "validate.$model",
                    },
                  ],
                  staticClass: "regular uneditable",
                  attrs: {
                    name: "jleague_id",
                    type: "text",
                    placeholder: "ＪリーグID",
                  },
                  domProps: { value: _vm.validate.$model },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.validate, "$model", $event.target.value)
                      },
                      _vm.setUserInfoPatch,
                    ],
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.validate.$model,
                      expression: "validate.$model",
                    },
                  ],
                  staticClass: "regular uneditable",
                  attrs: {
                    readonly: _vm.readonly,
                    disabled: _vm.disabled,
                    name: "jleague_id",
                    type: "text",
                    placeholder: "ＪリーグID",
                  },
                  domProps: { value: _vm.validate.$model },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.validate, "$model", $event.target.value)
                      },
                      _vm.setUserInfoPatch,
                    ],
                  },
                }),
          ]
        : [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.validate.$model,
                  expression: "validate.$model",
                },
              ],
              staticClass: "regular",
              attrs: {
                readonly: _vm.readonly,
                disabled: _vm.disabled,
                name: "jleague_id",
                type: "text",
                placeholder: "ＪリーグID",
              },
              domProps: { value: _vm.validate.$model },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.validate, "$model", $event.target.value)
                  },
                  _vm.setUserInfoPatch,
                ],
              },
            }),
          ],
      _vm._v(" "),
      !_vm.isDuplicateJleagueId || !_vm.isEmailToken
        ? _c("span", [
            _vm.isSignup
              ? _c(
                  "span",
                  {
                    staticClass: "annotation",
                    staticStyle: { "margin-top": "6px" },
                  },
                  [
                    _vm._v(
                      "新規登録時にＪリーグIDは変更できません。変更する場合は、登録完了後、メインメニューの「登録内容を変更する」から変更可能です。"
                    ),
                  ]
                )
              : _c(
                  "span",
                  {
                    staticClass: "annotation",
                    staticStyle: { "margin-top": "6px" },
                  },
                  [
                    _vm._v(
                      "使用できる文字は半角の英字と半角数字、半角記号 @_+!*/.- です。"
                    ),
                  ]
                ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }